<div class="container-search-module">
	@if (queryOptions) {
		<div class="mb-[8px] mt-[30px]">
			<lbca-search-box
				[placeholder]="'Localize os casos a partir da pesquisa por qualquer coluna'"
				[queryOptions]="queryOptions"
				[tagList]="tagList"
				(clear)="clearSearchValue()"
				(clearSearchFunction)="clearSearchFunction($event)"
				(searchValue)="setSearchValue($event)"
				[disabled]="disabled"
			></lbca-search-box>
		</div>
	}
	@if (!loadPage) {
		<lbca-loading class="show z-[1100]" position="relative"></lbca-loading>
	}

	@if (table.body.length === 0 && loadPage && feedback) {
		<div
			class="w-full h-full relative flex justify-center items-center flex-col mt-[50px] transition duration-600 ease-in-out show"
		>
			<lbca-body-feedback place="body" feedbackIcon="notfound" type="row">
				<ng-container rowMessagePrimary>Nenhum caso encontrado!</ng-container>
			</lbca-body-feedback>
		</div>
	}

	@if (table.body.length > 0) {
		<div class="mt-[50px] mb-[20px]">
			<lbca-table [table]="table" (clickLine)="clickLine($event)"></lbca-table>
		</div>
	}

	<ng-template #currentStatus let-process>
		@if (process.status === 'open' && process.integrationStatus !== 'sincronizando') {
			<span class="text-base text-gray-600 w-72 h-[22px] flex items-center justify-center">
				Em aberto
			</span>
		}
		@if (process.status === 'open' && process.integrationStatus === 'sincronizando') {
			<span class="text-base text-gray-600 w-72 h-[22px] flex items-center justify-center">
				Sincronizando
			</span>
		}
		@if (process.status === 'finished') {
			<span
				class="bg-primary rounded text-base text-gray-50 w-72 h-[22px] flex items-center justify-center"
			>
				Concluído
			</span>
		}
	</ng-template>
</div>
